import React from 'react';
import { alloy } from '@cimpress/react-components/lib/colors';

const VerticalRule = () => <div style={{ borderLeft: `1px solid ${alloy}`, margin: '0 10px' }} />;

export default VerticalRule;
